import React, { Fragment } from "react";
import styled from "styled-components";
import _ from "lodash";
import { connect } from "formik";
import { Grid } from "@material-ui/core";
import { AutoCompleteInput, TextInput } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const StyledAutoCompleteInput = styled(AutoCompleteInput)`
  &&&&{
    height:33px;
  }
`;
const SideLabelAutoCompleteWithRefInput = ({ label, fieldName, refFieldName, placeholder, formik, isDisabled, hasBorder, options, selectName, selectValue, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const { values } = formik;
  if (!selectName) {
    selectName = "name";
  }
  const val = _.get(formik.values, fieldName);
  let selectVal = _.find(options, { [selectValue]: val });
  if (!selectVal) {
    selectVal = { [selectName]: "--" };
  }
  const refVal = _.get(formik.values, refFieldName || `${fieldName}Ref`);

  return (
    <LateralField label={label} hasBorder={hasBorder}>
      {isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={10}>
            <ViewOnlyDiv>{selectVal[selectName]}</ViewOnlyDiv>
          </Grid>
          <Grid item xs={2}>
            <ViewOnlyDiv placeholder="No reference">{refVal}</ViewOnlyDiv>
          </Grid>
        </Grid>)}
      {!isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={9}>
            <StyledAutoCompleteInput
              formik={formik}
              fieldName={fieldName}
              options={options}
              selectName={selectName}
              selectValue={selectValue}
              {...otherProps}
            />
          </Grid>
          <Grid item xs={3}>
            <TextInput
              fullWidth
              fieldName={refFieldName || `${fieldName}Ref`}
              placeholder="Add a reference"
            />
          </Grid>
        </Grid>)}
    </LateralField>
  );
};
export default connect(SideLabelAutoCompleteWithRefInput);
